import { render, staticRenderFns } from "./CatalogPreviewCard.vue?vue&type=template&id=1a810177&"
import script from "./CatalogPreviewCard.vue?vue&type=script&lang=js&"
export * from "./CatalogPreviewCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports